import { render, staticRenderFns } from "./SciApplicationDetail.vue?vue&type=template&id=08345f24"
import script from "./SciApplicationDetail.vue?vue&type=script&lang=js"
export * from "./SciApplicationDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports